import { logError } from '@zg-rentals/log-error';

// Type definitions
type StorageType = 'localStorage' | 'sessionStorage';

interface UserTokenStorage {
  userToken: string | null;
  storeOldCred(token: string): void;
}

interface StoredNotificationData {
  time: number;
  timeToWait: number;
}

export const storageAvailable = (type: StorageType): boolean | undefined => {
  if (__BROWSER__) {
    try {
      const storage = window[type];
      const x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
    } catch (e) {
      return false;
    }
  }
  return undefined;
};

export const userTokenStorage: UserTokenStorage = {
  userToken: null,
  storeOldCred(token: string): void {
    this.userToken = token;
  },
};

export const getNotificationDisplay = (localStorageKey: string): boolean => {
  try {
    if (storageAvailable('localStorage')) {
      const disabledInfoFromLocalStorage = window.localStorage.getItem(localStorageKey);
      const now = Date.now();

      if (disabledInfoFromLocalStorage) {
        const parsedData = JSON.parse(disabledInfoFromLocalStorage) as StoredNotificationData;

        // should reset and show the notification
        if (now - parsedData.time >= parsedData.timeToWait) {
          const serializedData = JSON.stringify({
            time: now,
            timeToWait: 0,
          });

          window.localStorage.setItem(localStorageKey, serializedData);

          // enough time has passed since the last dismiss
          return true;
        } else {
          // not enough time has passed since the last dismiss
          return false;
        }
      } else {
        // nothing in localStorage, should display
        return true;
      }
    } else {
      // no localStorage

      return true;
    }
  } catch (e) {
    logError({
      error: e as Error,
      context: `Error getting NotificationDisplay from localStorage with localStorageKey: ${localStorageKey}`,
    });

    return false;
  }
};
